import Vue from 'vue'
import { SETTINGS as STATIC_SETTINGS } from '@/js/shared/static-strings.js'

const state = {
  debugMode: false,
  decimalAccuracy: 3,
  currency: null, // currencyID
  dict: {} // the entire raw dict
}

const mutations = {
  SET_DEBUG_MODE (state, mode) {
    state.debugMode = mode
  },
  SET_DECIMAL_ACCURACY (state, accuracy) {
    state.decimalAccuracy = accuracy
  },
  SET_CURRENCY (state, currency) {
    state.currency = currency
  },
  FETCH (state, _settings) {
    try {
      var settings = _settings.reduce((a, i) => {
        a[i.name] = i.value
        return a
      }, {})
      state.dict = settings
      state.currency = parseInt(settings[STATIC_SETTINGS.DEFAULT_CURRENCY])
    } catch (e) {
      console.log(e)
    }
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('settings/store')
      .then(response => {
        commit('FETCH', response.data.rows)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
